import { data } from '../../svg/ChevronLeft/data';
import { makeIcon } from '../makeIcon';

export const ChevronLeft = makeIcon(data, 'chevron_left', 'ChevronLeft');

export default ChevronLeft;
